// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export const PriceWrapper = styled.div`
  display: flex;
  width: fit-content;
  flex-direction: column;
  row-gap: 2px;
  min-height: 35px;
  @media ${(props) => props.theme.mediaQuery.large} {
    min-height: 48px;
  }
`;

export const ListPriceWrapper = styled.div`
  display: flex;
  column-gap: 6px;
  @media ${(props) => props.theme.mediaQuery.large} {
    column-gap: 8px;
  }
`;

export const OfferPrice = styled.span`
  font-family: Nunito;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 19px;
  color: ${(props) => props.theme.colorPalette.red[500]};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: 20px;
    line-height: 27px;
  }
`;

export const StrikedThroughPrice = styled.span`
  font-family: Nunito;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  text-decoration-line: line-through;
  color: ${(props) => props.theme.colorPalette.gray[800]};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: 14px;
    line-height: 19px;
  }
`;

export const MerchantTag = styled.span`
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  color: ${(props) => props.theme.colorPalette.red[500]};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: 14px;
    line-height: 19px;
  }
`;

export default css`
  &.keep-alive-text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: ${({ theme }) => theme.fonts.fontWeight.extrabold};
    font-family: ${({ theme }) => theme.fonts.secondaryFontFamily};
  }
`;
